// extracted by mini-css-extract-plugin
export default {"faqs":"responsiveStyles_faqs__RXyN3"};